export default {
  name: 'project-management',
  translationKey: 'project-management-module',
  routePrefix: 'project-management',
  routeNamePrefix: 'admin.project-management',
  directRoutesAvailable: false,
}
